import React from 'react';
import classNames, { Argument } from 'classnames';

import { AbstractMedia } from 'types/AbstractMedia';

import File, { FileProps } from './File';
import Carousel, { CarouselProps } from './Carousel';
import { useIntl } from 'react-intl';

type FileListProps = {
  className?: Argument;
  medias: AbstractMedia[];
  autoplay?: boolean;
} & Pick<FileProps, 'onDelete' | 'hideFilename'> & Pick<CarouselProps, 'showDownload'>;

const FileList: React.FC<FileListProps> = ({
  className, medias, autoplay, onDelete, showDownload, hideFilename,
}) => {
  const intl = useIntl();
  const [defaultCarouselMediaIndex, setDefaultCarouselMediaIndex] = React.useState(-1);

  const handleShowCarousel = React.useCallback((index: number) => () => {
    setDefaultCarouselMediaIndex(index);
  }, []);

  const handleHideCarousel = React.useCallback(() => {
    setDefaultCarouselMediaIndex(-1);
  }, []);

  return (
    <>
      <ul className={classNames('flex flex-wrap', className)}>
        {medias?.map((media, index) => (
          <li
            key={media.id ?? media.uploadId ?? media.path}
            className="aspect-square w-[calc(25%-0.5rem)] kiosk:w-[calc(25%-1rem)] xs:w-[calc(50%-0.5rem)] sm:w-[calc(20%-1rem)] h-fit! m-1 kiosk:m-2"
            aria-label={intl.formatMessage({ id: 'accessibility.button.viewMedia', defaultMessage: 'View the media' })}
          >
            <File
              {...media}
              onDelete={onDelete}
              className="w-full h-full kiosk:w-full kiosk:h-full"
              hideFilename={hideFilename}
              autoplay={autoplay && index === 0}
              onClick={handleShowCarousel(index)}
            />
          </li>
        ))}
        {defaultCarouselMediaIndex >= 0 && (
          <Carousel
            fullscreen
            medias={medias}
            onDelete={onDelete}
            showDownload={showDownload}
            onClose={handleHideCarousel}
            defaultMediaIndex={defaultCarouselMediaIndex}
          />
        )}
      </ul>
    </>
  );
};

export default FileList;
